import type { SchemaLookupToolDefinitionInput } from '../../lib/api';
import type { LookupSchemaSetup } from './lookup-tool-model';
import styles from './LookupTool.module.css';

interface LookupReviewSummaryProps {
  setup: LookupSchemaSetup;
  draft: SchemaLookupToolDefinitionInput;
}

/** Final read-back of what the configured lookup will do at runtime. */
export const LookupReviewSummary = ({ setup, draft }: LookupReviewSummaryProps) => {
  const relationship = setup.userIdField
    ? `Current contact external ID → ${setup.userIdField}`
    : 'Relationship unavailable';
  const returnedFields = setup.returnedFields.map(field => field.name).join(', ') || 'None';
  const filters =
    draft.lookup_config.filters
      .map(filter => `${filter.field} = ${String(filter.value)}`)
      .join(' AND ') || 'None';

  return (
    <dl className={styles.review}>
      <div>
        <dt>Schema</dt>
        <dd>{setup.name}</dd>
      </div>
      <div>
        <dt>Relationship</dt>
        <dd>{relationship}</dd>
      </div>
      <div>
        <dt>Returned fields</dt>
        <dd>{returnedFields}</dd>
      </div>
      <div>
        <dt>Filters</dt>
        <dd>{filters}</dd>
      </div>
      <div>
        <dt>Limit</dt>
        <dd>{draft.lookup_config.limit}</dd>
      </div>
    </dl>
  );
};
